/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2PostPayment/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2PostPayment({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2PostPayment",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#fff"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2PostPayment.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-P9Qy6': alignSelf,'--mt-2-P9Qy6': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-P9Qy6': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-P9Qy6': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-P9Qy6': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-P9Qy6': opacity,'--w-10-P9Qy6': typeof width === 'number' ? `${width}px` : width,'--h-11-P9Qy6': typeof height === 'number' ? `${height}px` : height,'--f-12-P9Qy6': fill,'--a-7-P9Qy6': isAnimated ? animation : "none",'--sd-8-P9Qy6': isAnimated ? strokeDashoffset : 0,'--sd-9-P9Qy6': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2PostPayment.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M1.5 4.327H5V6.11c0 1.125.895 2.036 2 2.036s2-.911 2-2.036V4.327h3.5c.828 0 1.5.684 1.5 1.528v6.618c0 .843-.672 1.527-1.5 1.527h-11C.672 14 0 13.316 0 12.473V5.855c0-.844.672-1.528 1.5-1.528zm1.504 5.717a.63.63 0 00-.625.636c0 .352.28.637.625.637h3.5a.63.63 0 00.625-.637.63.63 0 00-.625-.636h-3.5zm8.82.636c0 .703-.56 1.273-1.25 1.273s-1.25-.57-1.25-1.273.56-1.273 1.25-1.273 1.25.57 1.25 1.273zM7.75 6.11a.757.757 0 01-.75.763.757.757 0 01-.75-.764V3.055H5a.5.5 0 01-.462-.315.516.516 0 01.108-.555l2-2.036a.496.496 0 01.708 0l2 2.036a.516.516 0 01.108.555.5.5 0 01-.462.315H7.75v3.054z"
 style={{'--f-12-P9Qy6': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}